"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class Index {
    constructor(parent) {
        this.parent = parent;
        this.rc = parent.rc;
    }
    path() {
        return `${this.parent.path()}/token`;
    }
    /**
     * Returns access (and potentially refresh) tokens for making API requests.
   *
   * Depending on client application type
   * requests to this endpoint may require authentication with HTTP Basic scheme
   * using registered client ID and client secret as login and password, correspondingly.
   *
     * HTTP Method: post
     * Endpoint: /restapi/oauth/token
     * Rate Limit Group: Auth
     */
    async post(getTokenRequest, restRequestConfig) {
        const r = await this.rc.post(this.path(), getTokenRequest, undefined, restRequestConfig);
        return r.data;
    }
}
exports.default = Index;
//# sourceMappingURL=index.js.map